import { createScenario } from '@funtech-int/rival';
import { lazy } from '@funtech-int/rival-react';

import { RouteSkeleton } from '@/shared/components/PageSpinner/PageSpinner';

import { adminFamilyAddRoute, profilesRoute } from './routes';
import { profilesScreenWidget } from './widgets';
import { ProfilesScreen } from './components/ProfilesScreen/ProfilesScreen';

const scenario = createScenario((ctx) => {
    ctx.addRoute({
        route: profilesRoute,
        meta: {
            plusPaymentPage: 'Profiles',
            page: 'profiles',
        },
        component: lazy(() => import('./components/Profiles/Profiles')),
        fallback: RouteSkeleton,
    });

    ctx.addRoute({
        route: adminFamilyAddRoute,
        meta: {
            plusPaymentPage: 'AdminFamilyAdd',
            page: 'admin-family-add',
        },
        component: lazy(
            () => import('./components/AdminFamilyAddPermission/AdminFamilyAddPermissionContainer')
        ),
        fallback: RouteSkeleton,
    });

    ctx.addWidget({
        widget: profilesScreenWidget,
        component: ProfilesScreen,
    });
});

export * from './routes';

export default scenario;
